<template>
  <div id="connectus_div_touchstart" class="contact-us-section"  @touchstart="touchstart($event)" @touchend="touchend($event,1,'我们的优势')"  v-if="product_id != 'rats'">
    <div class="flex-h-center">
      <div class="slash header mr10"></div>
      <div class="f32 blue-1 light">{{title}}</div>
      <div class="slash header ml10"></div>
    </div>

    <van-swipe id="connectus_van_imgClick_mt32" :autoplay="5000" :loop="true" class="slider-wrapper mt32" @change="imgClick">

      <van-swipe-item v-for="(item, index) in list" :key="index" class="slider-page">
        <div class="slice left">
          <div class="diamond" :style="title != '我们的优势'?'background-color: #ececec;': 'background-color: #fff;'">
            <img class="bg" :alt="'拜耳虫虫拜拜 | ' + item[0].title" :src="require('../assets/img/resources/contact_us/' + item[0].img)"/>
          </div>
          <div class="diamond-desc left">
            <div class="diamond-content">
              <div class="diamond-content-title bold white">{{item[0].title}}</div>
              <div class="diamond-content-subtitle light white">{{item[0].text}}</div>
            </div>
          </div>
        </div>
        <div class="slice right">
          <div class="diamond" :style="title != '我们的优势'?'background-color: #ececec;': 'background-color: #fff;'">
            <img class="bg" :alt="'拜耳虫虫拜拜 | ' + item[1].title" :src="require('../assets/img/resources/contact_us/' + item[1].img)"/>
          </div>
          <div class="diamond-desc right">
            <div class="diamond-content">
              <div class="diamond-content-title bold white">{{item[1].title}}</div>
              <div class="diamond-content-subtitle light white">{{item[1].text}}</div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div v-show="title != '我们的优势'" class="contact-action-wrapper flex-row mt45" style="position: relative;">
      <div class="diamond-btn-wrapper flex-row">
        <a id="connect_a_detailLink_left" class="diamond-btn left" href="javascript:;" @click="detailLink()" style="z-index: 9;" data-fuget="283">
          <div class="diamond"></div>
          <div class="title">{{contains.common.personal_service}}</div>
        </a>
        <a id="connect_a_utils_right" class="diamond-btn right slash-btn" @click="utils.ga.cta('Non-Resident')" :href="$rootUrl+'/enterprise'"
            data-fuget="283">
          <div class="diamond" style="background-color: #00BCFF;"></div>
          <div class="title">{{contains.common.enterprise_service}}</div>
        </a>
      </div>
      <WeChatCode v-show="showCode1" style="top: 60px;left: 0px;" :product_id="product_id"></WeChatCode>
    </div>

    <el-dialog
      title=""
      top="20vh"
      :visible.sync="weixinDialogImg"
      class="weixin-dialog-img">
      <div class="con" v-if="codeImg == ''">
        <img v-lazy="require('@/assets/images/newhome/404.png')" style="width: 50%; height: auto;" />
        <p style="color: #4D4CC1;">服务即将上线，敬请期待</p>
      </div>
      <div class="con" v-else>
        <img v-lazy="require('@/assets/images/newhome/' + codeImg + '.png')" />
        <p>请微信扫码查看相关详情</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import '@/styles/pest_wiki/global2.less';
  import '@/styles/pest_wiki/pest_wiki_detail.less';
  import contains from '@/controller/contains'
  import datas from '@/controller/data'
  import utils from '@/controller/utils'
  import WeChatCode from '@/components/weChatCode'
  import { get_url_link_for_product } from '@/api/api';

  export default {
    name: "connect_us",
    components: {
      'WeChatCode': WeChatCode
    },
    props: ['title', 'product_id', 'equipment', 'jump_to_detail','status2','isPhoneSize'],
    data() {
      return {
        contains: contains,
        datas: datas,
        utils: utils,
        showCode1: false,
        status:0,
        num_status:'',
        direction:'',
        list: {
          1: [
            {
              title: '无忧保障',
              text: '专业全面的售后支持和保障，免去后顾之忧',
              img: 'contact_us_3.png'
            },
            {
              title: '快速上门',
              // text: '拜耳进口药剂，环保无异味，保证家人和宠物健康',
              text: '在线下单，快速预约专家，上门服务',
              img: 'contact_us_4.png'
            }
          ],
          2: [
            {
              title: '全程托付',
              text: '无需再亲自动手，一步到位，省心放心',
              img: 'contact_us_5.png'
            },
            {
              title: '德国品质',
              text: '严格质量把控，全程系统记录',
              img: 'contact_us_6.png'
            }
          ],
          3: [
            {
              title: '专业科学',
              text: '国际技术培训，100%持证 上岗，量身定制解决方案',
              img: 'contact_us_1.png'
            },
            {
              title: '安全环保',

              text: '拜耳进口药剂，环保无异味，保证家人和宠物健康',
              img: 'contact_us_2.png'
            }
          ]
        },
        weixinDialogImg: false,
        codeImg: 'wx01'
      }
    },
    watch:{
      status2(data){
        console.log('data-status2',data)
         this.status = data;
      }
    },
    mounted(){
      console.log('status2',this.status2)
    },
    methods: {
      // imgClick (event, data, label ,index) {
      //   for (let index in data[event]) {
      //     if (index != 'remove') utils.ga.carousel('View - ' + data[event][index].title, label);
      //     console.log('data[event][index].title',data[event][index].title)
      //   }

      // },
      linkwxShow(name) {
        this.codeImg = name
        this.weixinDialogImg = true
      },
      detailLink(){
          let self = this
          if(self.product_id == 'cockroach') {
            if(self.isPhoneSize){
              self.getUrlLink('cockroachLite')
            }else{
              self.linkwxShow('wx02')
            }
            return
          }
          if(self.product_id == 'white_ant_check') {
            if(self.isPhoneSize){
              self.getUrlLink('white_ant_stand')
            }else{
              self.linkwxShow('wx04')
            }
            return
          }
          if(self.product_id == 'ants') {
            if(self.isPhoneSize){
              self.getUrlLink('antsPlus')
            }else{
              self.linkwxShow('wx06')
            }
            return
          }
          if(self.product_id == 'flea') {
            if(self.isPhoneSize){
              self.getUrlLink('fleaPlus')
            }else{
              self.linkwxShow('wx05')
            }
            return
          }
          if(self.product_id == 'mosquito') {
            if(self.isPhoneSize){
              self.getUrlLink('mosquito')
            }else{
              self.linkwxShow('wx07')
            }
            return
          }

          if(self.isPhoneSize){
            self.getUrlLink('pest_management') //百虫无忧
          }else{
            self.linkwxShow('wx01')
          }
      },
      getUrlLink(id){
        let self = this
        let params = {
          productId: id,
        }
        get_url_link_for_product(params).then((res) => {
          if(res.data.err == 0){
            console.log('url',res.data.data)
            location.href = res.data.data
          }else{
            self.$message.error(res.data.msg);
          }
        });
      },
      // detailLink(){
      //    let self = this
      //    if(self.product_id == 'cockroach' || self.product_id == 'rats'){
      //      let _id =  self.product_id == 'cockroach' ? 'zhanglang' : 'laoshu'
      //      self.$router.push({path: '/service/' + _id })
      //    }else{
      //      window.location.href = self.$rootUrl + '/mobile/service_detail/' + (self.utils.product_id_boolean_mobile(self.product_id)? self.product_id: 'unknownpest2')
      //    }
      // },
        touchstart(e){
        var x = e.targetTouches[0].pageX;
        this.pagex = x;
      },
      touchend(e,type = 0,name = '',c = ''){
        var that = this;
        var x = e.changedTouches[0].pageX;
        var oldX = this.pagex;
        if(type == 0){
          if(x < oldX){
            // console.log('向左滑动')
            // utils.ga.sliderDirection('Move-left');
          }else{
            // console.log('向右滑动');
            // utils.ga.sliderDirection('Move-right');
          }
        }else{
            if(x < oldX){
              console.log('向左滑动')
              that.num_status = true;
              that.direction = '向左滑动';
              that.num_set_timeout = setTimeout(function (){
                that.num_status = false;
                //  that.direction = '';
              },3000);
            }else{
              console.log('向右滑动');
              that.num_status = true;
              that.direction = '向右滑动';
              that.num_set_timeout = setTimeout(function (){
                that.num_status = false;
                // that.direction = '';
              },3000);
            }
        }
      },
      imgClick (index) {
        var that = this;
        clearTimeout(that.num_set_timeout)
        setTimeout(function (){
          // console.log('num_status',that.num_status)
          var direction = that.direction;
          // console.log('direction',direction)
          if(that.num_status){
            if(direction == '向左滑动'){
              // utils.ga.carousel('Next',name);
              // console.log('Next')
            }else if(direction == '向右滑动'){
              // utils.ga.carousel('Previous',name);
              // console.log('Previous')
            }
            that.num_status = false;
            that.direction = '';
          }
          that.num = index;
        },500);
      },
      naviteTo(show) {
        this.utils.fuget(313)
        if (this.equipment == 'pc') {
          if (show == 0) this.showCode = !this.showCode;
          else this.showCode1 = !this.showCode1;
        } else {
          if (this.product_id) {
            console.log(this.$route)
            window.location.href = this.$rootUrl + '/mobile/service_detail/' + this.product_id
          } else {
            window.location.href = this.$rootUrl
          }

        }
      },
      showCodeClick() {
        this.utils.ga.cta('Resident')
        if (this.jump_to_detail) {
          console.log(this.product_id)
          if (this.utils.product_id_boolean(this.product_id)) {
            this.$router.push({path: `/service/${this.datas.product_list[this.product_id].product_name}`})
          } else {
            this.$router.push({path: '/service/profession'})
          }
          //
        } else {
          this.showCode = !this.showCode;
        }
        this.utils.fuget(283);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/connect_us.vue